var _rect, _rect2, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVtt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.000976562,
    width: 32,
    height: 32,
    rx: 8,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.500977,
    width: 39,
    height: 39,
    rx: 7.5,
    fill: "url(#paint0_linear_107_4794)",
    stroke: "#E9E0FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.51102 17.8684C8.27785 17.2911 8.70279 16.6611 9.32544 16.6611C9.46544 16.6611 9.57944 16.6951 9.66744 16.7631C9.75544 16.8311 9.82144 16.9191 9.86544 17.0271L11.9054 22.3191C11.9734 22.4911 12.0374 22.6811 12.0974 22.8891C12.1454 23.0419 12.3899 23.0371 12.4333 22.8829C12.4899 22.6817 12.552 22.4938 12.6194 22.3191L14.6534 17.0271C14.6894 16.9351 14.7534 16.8511 14.8454 16.7751C14.9374 16.6991 15.0514 16.6611 15.1874 16.6611C15.8101 16.6611 16.235 17.2911 16.0019 17.8684L13.2584 24.6612C13.0935 25.0697 12.697 25.3371 12.2564 25.3371C11.8159 25.3371 11.4194 25.0697 11.2544 24.6612L8.51102 17.8684Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.846 16.6611C23.2121 16.6611 23.509 16.958 23.509 17.3241C23.509 17.6903 23.2121 17.9871 22.846 17.9871H22.204C21.4832 17.9871 20.899 18.5714 20.899 19.2921V24.5301C20.899 24.9758 20.5377 25.3371 20.092 25.3371C19.6463 25.3371 19.285 24.9758 19.285 24.5301V19.2981C19.285 18.5741 18.698 17.9871 17.974 17.9871H17.326C16.9598 17.9871 16.663 17.6903 16.663 17.3241C16.663 16.958 16.9598 16.6611 17.326 16.6611H22.846Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9827 16.6611C30.3489 16.6611 30.6457 16.958 30.6457 17.3241C30.6457 17.6903 30.3489 17.9871 29.9827 17.9871H29.3407C28.62 17.9871 28.0357 18.5714 28.0357 19.2921V24.5301C28.0357 24.9758 27.6744 25.3371 27.2287 25.3371C26.783 25.3371 26.4217 24.9758 26.4217 24.5301V19.2981C26.4217 18.5741 25.8347 17.9871 25.1107 17.9871H24.4627C24.0965 17.9871 23.7997 17.6903 23.7997 17.3241C23.7997 16.958 24.0965 16.6611 24.4627 16.6611H29.9827Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_107_4794",
    x1: -20.4019,
    y1: -17.9022,
    x2: 81.2346,
    y2: 24.4292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.191253,
    stopColor: "#363E70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781794,
    stopColor: "#EC6AE5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVtt);
export default __webpack_public_path__ + "static/media/vtt.ce2719b5d2d35c30c1e1619aeae0a462.svg";
export { ForwardRef as ReactComponent };